
<template>
    <div class="rejectmsg mt-3 mb-3" v-if="is_reject">
        <div>ЗАЯВКА ВІДХИЛЕНА
        </div>
        <div v-html="this.tender.request?.reject_reason"></div>
    </div>
</template>

<script>
export default {
    name: "application_reject",
    props : {
        tender : {
            type : Object,
            required : true
        }
    },
    
    computed : {
        is_reject() {
            return this.tender.request.status == 'reject';
        }
    }
}
</script>
<style scoped>
.rejectmsg
{
    color: red;
    background-color: aliceblue;
    border: 1px solid;
    text-align: center;
    padding: 5px;
    margin-bottom: 10px;
}
</style>